var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 28,
    viewBox: "0 0 32 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6674 0C11.8816 0 8.8129 3.06874 8.8129 6.85448C8.8129 9.91506 13.2928 15.4933 15.0091 17.5181C15.3568 17.9283 15.9786 17.9283 16.3256 17.5181C18.042 15.4933 22.5219 9.91506 22.5219 6.85448C22.5219 3.06874 19.4531 0 15.6674 0ZM15.6674 9.13931C14.4053 9.13931 13.3826 8.11658 13.3826 6.85448C13.3826 5.59238 14.4053 4.56965 15.6674 4.56965C16.9295 4.56965 17.9522 5.59239 17.9522 6.85448C17.9522 8.11658 16.9295 9.13931 15.6674 9.13931ZM1.09454 11.7478C0.433611 12.0122 0.000158823 12.6522 0 13.3641V26.9816C0 27.5974 0.621799 28.0185 1.19355 27.79L8.7041 24.3715V11.6918C8.2232 10.8225 7.82988 9.97599 7.54809 9.16651L1.09454 11.7478ZM15.6674 19.5663C14.902 19.5663 14.1779 19.2301 13.6812 18.6436C12.6117 17.3815 11.4742 15.9443 10.4449 14.47V24.3709L20.8898 27.8526V14.4706C19.8606 15.9443 18.7236 17.3821 17.6536 18.6442C17.1569 19.2301 16.4328 19.5663 15.6674 19.5663ZM30.1412 8.76721L22.6307 12.1857V27.8531L30.2402 24.8094C30.9013 24.5452 31.3348 23.9051 31.3348 23.1932V9.5756C31.3348 8.95978 30.713 8.53872 30.1412 8.76721Z",
    fill: "#D32F2F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.687f0ceda0229b97b68076f9d380193c.svg";
export { ForwardRef as ReactComponent };